import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { loginTimeOutAndRedirectHandler } from '../../Utility/LoginTimeOutAndRedirectHandler/LoginTimeOutAndRedirectHandler';
import MenuIcon from '@mui/icons-material/Menu';
import { generateRandomString } from '../../Utility/GenerateRandomString/GenerateRandomString';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import Grid from '@mui/material/Grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import CircularProgress from '@mui/material/CircularProgress';
import { TableRow, TableCell } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setAllDataOfContact, setSearchedDataOfContact } from '../../Redux/Index';
import SearchIcon from '@mui/icons-material/Search';
import { connect } from 'react-redux';
import { fetchAllDataOfContact } from '../../Utility/FetchAllData/FetchAllData';
import cusStyles from './Search.module.css'
import { useParams } from 'react-router-dom';
import SearchNav from './SearchNav';
import SearchTable from './SearchTable';
import { verifyCookie } from '../../Utility/VerifyCookie/VerifyCookie';
import { passwordChangeHandleChangeFunc } from '../PasswordChange/PasswordChangeHandleChangeFunc';
import { passwordChangeSubmitFunc } from '../PasswordChange/PasswordChangeSubmitFunc';
import PasswordChangeUi from '../PasswordChange/PasswordChangeUi';
import ClearIcon from '@mui/icons-material/Clear';
import { changeToReadableDate } from '../../Utility/ChangeToReadableDate/ChangeToReadableDate';

// Redux func start 

const mapStateToPropsForAllData = state => {
  return {
    allDataOfContact: state.allDataOfUser.allDataOfContact,
    searchedDataOfContact: state.allDataOfUser.searchedDataOfContact
  }
}

const mapDispatchToPropsForAllData = dispatch => {
  return {
    SET_ALL_DATA_OF_CONTACT_STATE: (allDataOfContactValue) => dispatch(setAllDataOfContact(allDataOfContactValue)),
    SET_SEARCHED_DATA_OF_CONTACT_STATE: (searchedDataOfContactValue) => dispatch(setSearchedDataOfContact(searchedDataOfContactValue))
  }
}

// Redux func end

// Hamburger and theme func start

const drawerWidth = 0;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const defaultTheme = createTheme();

function Search( { allDataOfContact, searchedDataOfContact } ) {  

  let currentPasswordErrorState = false;
  let newPasswordErrorState = false;
  let reNewPasswordErrorState = false;
  let overAllError = false;
  let currentPasswordErrorMessage = "";
  let newPasswordErrorMessage = "";
  let reNewPasswordErrorMessage = "";
  let overAllErrorMessage = "";

  var currentPageUrl = window.location.href;
        var urlParts = currentPageUrl.split('/');
        var urlSearchParams = "";
        if (urlParts.length >= 4) {
          if(urlParts[4] != "") {
          urlSearchParams = urlParts[4];
          }
          if(urlSearchParams) {
              urlSearchParams = urlSearchParams.replace(/%20/g, ' ');
          } else {
            urlSearchParams = "";
          }
        } else {
          console.log("Not enough parts in the URL");
        }

  const { searchedKeyword } = useParams();
  const [searchTerm, setSearchTerm] = useState(searchedKeyword);
  const [gotData, setGotData] = useState(false);
  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [errorFromServer, setErrorFromServer] = useState("");
  const [isFormSubmitButtonClicked, setIsFormSubmitButtonClicked] = useState(false);
  const [changePasswordVal, setChangePasswordVal] = useState({
    currentPassword: "",
    newPassword: "",
    reNewPassword: ""
  });

  // Hamburger and theme func end

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [cookies, removeCookie] = useCookies([]);
  useEffect(() => {

    verifyCookie(cookies, navigate);

    if(gotData == false && (sessionStorage.getItem("GdEGeSTESGEt2ERgsdf34GEEr") && sessionStorage.getItem("GdEGeSTESGEt2ERgsdf34GEEr") == "sGsdkE34GseGHrSDX2F")) {

      loginTimeOutAndRedirectHandler(fetchAllDataOfContact, "", dispatch, setAllDataOfContact, navigate, "/", "", "", "", setGotData);
    }

    searchKeywordFromData(searchTerm);

  }, [cookies, navigate, removeCookie, dispatch, gotData]);

  // Search data func start

  function searchTheData(searchingKeyword, searchObj, searchField) {
    let searchingExactWord = searchingKeyword.toLowerCase();

    let searchedData = allDataOfContact?.data?.[searchObj]?.records?.filter((filData) => {
        let dataOfContact = filData?.[searchField]?.toLowerCase();
        if(dataOfContact?.includes(searchingExactWord)) {
            return filData
        }
    })
    return searchedData;
  }

  function searchKeywordFromData(searchingKeyword) {
    if(searchingKeyword != "") {
      let searchedObjectValue = {
        "success": true,
        "isUpdatedVal": false,
        "data": {
            "Cases": {
                "totalSize": 0,
                "done": true,
                "records": []
            },
            "Leads": {
                "totalSize": 0,
                "done": true,
                "records": []
            },
            "Opportunities": {
                "totalSize": 0,
                "done": true,
                "records": []
            },
            "Contacts": {
                "totalSize": 0,
                "done": true,
                "records": []
            },
            "Accounts": {
                "totalSize": 0,
                "done": true,
                "records": []
            }
        }
    }

    let searchedCaseData = searchTheData(searchingKeyword, "Cases", "Subject");
    if(typeof searchedCaseData != 'undefined') {
      searchedObjectValue?.data?.Cases?.records?.push(...searchedCaseData);
      searchedObjectValue.data.Cases.totalSize = searchedCaseData.length;
    }

    let searchedLeadData = searchTheData(searchingKeyword, "Leads", "Name");
    if(typeof searchedLeadData != 'undefined') {
      searchedObjectValue?.data?.Leads?.records?.push(...searchedLeadData);
      searchedObjectValue.data.Leads.totalSize = searchedLeadData.length;
    }

    let searchedOpportunityData = searchTheData(searchingKeyword, "Opportunities", "Name");
    if(typeof searchedOpportunityData != 'undefined') {
      searchedObjectValue?.data?.Opportunities?.records?.push(...searchedOpportunityData);
      searchedObjectValue.data.Opportunities.totalSize = searchedOpportunityData.length;
    }

    let searchedContactData = searchTheData(searchingKeyword, "Contacts", "Name");
    if(typeof searchedContactData != 'undefined') {
      searchedObjectValue?.data?.Contacts?.records?.push(...searchedContactData);
      searchedObjectValue.data.Contacts.totalSize = searchedContactData.length;
    }

    let searchedAccountData = searchTheData(searchingKeyword, "Accounts", "Name");
    if(typeof searchedAccountData != 'undefined') {
      searchedObjectValue?.data?.Accounts?.records?.push(...searchedAccountData);
      searchedObjectValue.data.Accounts.totalSize = searchedAccountData.length;
      searchedObjectValue.isUpdatedVal = true;
    }


    setTheSearchedDataInRedux(searchedObjectValue);
    }
  }

  function setTheSearchedDataInRedux(searchedData) {
    dispatch(setSearchedDataOfContact(searchedData));
  }

  if(Object.keys(searchedDataOfContact).length == 0) {
    searchKeywordFromData(searchTerm);
  }

  function clearTheSearchKeyword() {
    setSearchTerm("");
  }
  
  // Search data func end

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Call for password change functionality start
  const handleOnChange = (e) => {
    passwordChangeHandleChangeFunc(e, setErrorFromServer, setChangePasswordVal, changePasswordVal);    
  };

  const {currentPassword, newPassword, reNewPassword } = changePasswordVal;

  // Password value verification func start 

  if(isFormSubmitButtonClicked) {

    let passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(?=.*[a-zA-Z0-9@#$%^&+=!]).{8,}$/;

    if (!currentPassword) {
      currentPasswordErrorState = true;
      currentPasswordErrorMessage = "Please enter the current password!";
    } else if (!currentPassword.match(passwordPattern)) {
      currentPasswordErrorState = true;
      currentPasswordErrorMessage = "Password is doesn't match the pattern!";
    } else {
      currentPasswordErrorState = false;
      currentPasswordErrorMessage = "";
    }

    if (!newPassword) {
      newPasswordErrorState = true;
      newPasswordErrorMessage = "Please enter the new password!";
    } else if (!newPassword.match(passwordPattern)) {
      newPasswordErrorState = true;
      newPasswordErrorMessage = "New password is doesn't match the pattern!";
    } else {
      newPasswordErrorState = false;
      newPasswordErrorMessage = "";
    }

    if (!reNewPassword) {
      reNewPasswordErrorState = true;
      reNewPasswordErrorMessage = "Please reenter the new password!";
    } else if (!reNewPassword.match(passwordPattern)) {
      reNewPasswordErrorState = true;
      reNewPasswordErrorMessage = "Reentered new password is doesn't match the pattern!";
    } else {
      reNewPasswordErrorState = false;
      reNewPasswordErrorMessage = "";
    }

    overAllError = false;
    overAllErrorMessage = "";

    if(currentPassword == newPassword) {
      if(currentPassword != "" && newPassword != "") {
      overAllError = true;
      overAllErrorMessage = "Current and new passwords are same!";
      }
    }

    if(newPassword != reNewPassword) {
      if(newPassword != "" && reNewPassword != "") {
        overAllError = true;
        overAllErrorMessage = "New and reentered passwords are not same!";
      }
    }

  }

  // Password value verification func end

  const handleSubmit = async(e) => {
    await passwordChangeSubmitFunc(e, setIsFormSubmitButtonClicked, isFormSubmitButtonClicked, currentPasswordErrorState, newPasswordErrorState, reNewPasswordErrorState, setIsFormSubmitted, changePasswordVal, setErrorFromServer, setChangePasswordVal, setIsPopupOpened);
  }

  // Call for password change functionality end

    
  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', 
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'left', display: { xs: 'none', sm: 'inline-block'} }}
            >
              <Link to="/Dashboard" style={{ textDecoration: 'none', color: 'inherit' }}>
              Dashboard
              </Link>
            </Typography>
            <div style={{ display: 'flex', height: '35px', width: '500px', backgroundColor: 'white', borderRadius: '5px', padding: '5px' }}>
                <input type="text" value={searchTerm} style={{ width: '100%', border: 'none', outline: 'none', padding: '10px', borderRadius: '5px 0px 0px 5px' }} placeholder="Search..." onChange={(e) => { setSearchTerm(e.target.value) }}  />
                { (urlSearchParams != "" && searchTerm != "") ? <div style={{ padding: '1.5px', borderRadius: '5px 5px 5px 5px', cursor: "pointer" }} ><ClearIcon className={cusStyles.searchClearBtn} onClick={clearTheSearchKeyword} style={{ fontSize: "12px" }} /></div> : "" }
                <div style={{ padding: '1.5px', borderRadius: '5px 5px 5px 5px', cursor: "pointer" }} ><SearchIcon className={cusStyles.searchBtn} onClick={() => { searchKeywordFromData(searchTerm) }} /></div>

            </div>
            <IconButton color="inherit" onClick={handleMenu}>
              <AccountCircleIcon style={{ height: '40px', width: '40px' }}></AccountCircleIcon>
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem><Link to="/Contacts" style={{ color: "inherit", textDecoration: "none" }}>My Profile</Link></MenuItem>
                <MenuItem><Link to="/Accounts" style={{ color: "inherit", textDecoration: "none" }}>My Account</Link></MenuItem>
                <MenuItem onClick={() => {setIsPopupOpened(true); handleClose();}}>Change Password</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
        { searchedDataOfContact.isUpdatedVal? <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <Grid container style={{ marginTop: "5px", position: "relative" }}>
            <Grid item xs={2} style={{ borderRight: "2px solid black", height: "100vh", position: "sticky", top: "50px" }}>
                <Grid item xs={12} style={{ margin: "10px 0px 5px 0px", lineHeight: "0px" }}>
                <h3>Search Results</h3>
                </Grid>
                <Grid item xs={12} style={{ margin: "0px", lineHeight: "0px", padding: "1px 0px", backgroundColor: "gainsboro" }}>
                <h5>Top Results</h5>
                </Grid>
                <List style={{ paddingRight: "10px" }}>

                <SearchNav entityType="Cases" searchTerm={searchTerm} data={searchedDataOfContact.data} />
                <SearchNav entityType="Leads" searchTerm={searchTerm} data={searchedDataOfContact.data} />
                <SearchNav entityType="Opportunities" searchTerm={searchTerm} data={searchedDataOfContact.data} />
                <SearchNav entityType="My Profile" searchTerm={searchTerm} data={searchedDataOfContact.data} />
                <SearchNav entityType="My Account" searchTerm={searchTerm} data={searchedDataOfContact.data} />

                </List>
            </Grid>
            <Grid item xs={10}>
              <SearchTable title="Cases" searchTerm={searchTerm} searchedDataOfContact={searchedDataOfContact} gotData={gotData} tableHeadings={["Case Number", "Subject", "Status", "Priority", "Phone", "Origin", "Date/Time Opened"]}>
              {searchedDataOfContact?.data && searchedDataOfContact?.data?.Cases?.records?.slice(0, 5).map((caseData) => { 
                
                const caseIdOfContact = generateRandomString()+"00JZ3"+caseData.Id+generateRandomString();
                const finalReadableDate = changeToReadableDate(caseData.CreatedDate);
                
                return (
                    <TableRow key={caseData.CaseNumber}>
                    <TableCell><Link to={`/CaseDetail/${caseIdOfContact}`} style={{ textDecoration: 'none', color: '#1976D2' }}>{caseData.CaseNumber}</Link></TableCell>
                    <TableCell>{caseData.Subject}</TableCell>
                    <TableCell>{caseData.Status}</TableCell>
                    <TableCell>{caseData.Priority}</TableCell>
                    <TableCell>{caseData.ContactMobile}</TableCell>
                    <TableCell>{caseData.Origin}</TableCell>
                    <TableCell>{finalReadableDate}</TableCell>
                    </TableRow>
                ) })}
              </SearchTable>
              <SearchTable title="Leads" searchTerm={searchTerm} searchedDataOfContact={searchedDataOfContact} gotData={gotData} tableHeadings={["Name", "Phone", "Company", "Email", "Industry", "Status"]}>
              {searchedDataOfContact?.data && searchedDataOfContact?.data?.Leads?.records?.slice(0, 5).map((leadData) => {
                const leadIdOfContact = generateRandomString()+"00JZ3"+leadData.Id+generateRandomString();
                return (
                  <TableRow key={leadData.Id}>
                  <TableCell><Link to={`/LeadDetail/${leadIdOfContact}`} style={{ textDecoration: 'none', color: '#1976D2' }}>{leadData.Name}</Link></TableCell>
                  <TableCell>{leadData.Phone}</TableCell>
                  <TableCell>{leadData.Company}</TableCell>
                  <TableCell>{leadData.Email}</TableCell>
                  <TableCell>{leadData.Industry}</TableCell>
                  <TableCell>{leadData.Status}</TableCell>
                  </TableRow>
              )
              } )}
              </SearchTable>

              <SearchTable title="Opportunities" searchTerm={searchTerm} searchedDataOfContact={searchedDataOfContact} gotData={gotData} tableHeadings={["Name", "Stage Name", "Lead Source", "Close Date", "Amount"]}>
              {searchedDataOfContact?.data && searchedDataOfContact?.data?.Opportunities?.records?.slice(0, 5).map((OpportunityData) => {
                const opportunityIdOfContact = generateRandomString()+"00JZ3"+OpportunityData.Id+generateRandomString();
                return (
                  <TableRow key={OpportunityData.Id}>
                  <TableCell><Link to={`/OpportunityDetail/${opportunityIdOfContact}`} style={{ textDecoration: 'none', color: '#1976D2' }}>{OpportunityData.Name}</Link></TableCell>
                  <TableCell>{OpportunityData.StageName}</TableCell>
                  <TableCell>{OpportunityData.LeadSource}</TableCell>
                  <TableCell>{OpportunityData.CloseDate}</TableCell>
                  <TableCell>{OpportunityData.Amount}</TableCell>
                  </TableRow>
              )
              } )}
              </SearchTable>

              <SearchTable title="My Profile" searchTerm={searchTerm} searchedDataOfContact={searchedDataOfContact} gotData={gotData} tableHeadings={["Name", "Phone", "Email", "Status", "Mobile", "Account Name"]}>
              {searchedDataOfContact?.data && searchedDataOfContact?.data?.Contacts?.records?.slice(0, 5).map((ContactData) => (
                    <TableRow key={ContactData.Id}>
                    <TableCell>{ContactData.Name}</TableCell>
                    <TableCell>{ContactData.Phone}</TableCell>
                    <TableCell>{ContactData.Email}</TableCell>
                    <TableCell>{ContactData.Status__c}</TableCell>
                    <TableCell>{ContactData.MobilePhone}</TableCell>
                    <TableCell>{ContactData.Account.Name}</TableCell>
                    </TableRow>
                ))}
              </SearchTable>

              <SearchTable title="My Account" searchTerm={searchTerm} searchedDataOfContact={searchedDataOfContact} gotData={gotData} tableHeadings={["Account Name", "Phone", "Industry", "Annual Revenue", "Type", "Address"]}>
              {searchedDataOfContact?.data && searchedDataOfContact?.data?.Accounts?.records?.slice(0, 5).map((accountData) => {
                    let addressDetail = `${accountData?.ShippingAddress?.street == null ? "" : accountData?.ShippingAddress?.street} ${accountData?.ShippingAddress?.city == null ? "" : accountData?.ShippingAddress?.city+", "} ${accountData?.ShippingAddress?.state == null ? "" : accountData?.ShippingAddress?.state+", "} ${accountData?.ShippingAddress?.country == null ? "" : accountData?.ShippingAddress?.country+", "} ${accountData?.ShippingAddress?.postalCode == null ? "" : accountData?.ShippingAddress?.postalCode+"."}`;
                    return (
                        <TableRow key={accountData.Id}>
                        <TableCell>{accountData.Name}</TableCell>
                        <TableCell>{accountData.Phone}</TableCell>
                        <TableCell>{accountData.Industry}</TableCell>
                        <TableCell>{accountData.AnnualRevenue}</TableCell>
                        <TableCell>{accountData.Type}</TableCell>
                        <TableCell>{addressDetail}</TableCell>
                        </TableRow>
                        ) 
                    })}
              </SearchTable>
            </Grid>
          </Grid>
        </Box> : <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '180px'  }}>
            <CircularProgress />
            </Box> }
        
      </Box>
      {/* Change password popup start */}
      <PasswordChangeUi isPopupOpened={isPopupOpened} currentPassword={currentPassword} currentPasswordErrorState={currentPasswordErrorState} currentPasswordErrorMessage={currentPasswordErrorMessage} handleOnChange={handleOnChange} newPassword={newPassword} newPasswordErrorState={newPasswordErrorState} newPasswordErrorMessage={newPasswordErrorMessage} reNewPassword={reNewPassword} reNewPasswordErrorState={reNewPasswordErrorState} reNewPasswordErrorMessage={reNewPasswordErrorMessage} overAllError={overAllError} isFormSubmitButtonClicked={isFormSubmitButtonClicked} overAllErrorMessage={overAllErrorMessage} errorFromServer={errorFromServer} setIsPopupOpened={setIsPopupOpened} handleSubmit={handleSubmit} isFormSubmitted={isFormSubmitted} />
      {/* Change password popup end */}
    </ThemeProvider>
  );
                
}

export default connect(mapStateToPropsForAllData, mapDispatchToPropsForAllData)(Search);